module.exports = __webpack_public_path__ + "img/denim_pro.39e55596.svg";